import PropertyDetails from './propertyDetails';

export default PropertyDetails;
